<template>
  <el-card>
    <div class="wrap-rub">
      <div class="wrap-left">
        <div class="title">
          <img src="https://public-static-edu.codemao.cn/redboat/courseManage/课程重难点.png" />
          <h3>本课程重难点！</h3>
        </div>
        <ul class="content">
          <li v-for="(item, index) in rubList" :key="index">
            <i class="icon el-icon-star-off"></i> &nbsp;
            <span>{{item}}</span>
          </li>
          <li v-if="rubStr">
            <i class="icon el-icon-star-off"></i> &nbsp;
            <span>{{rubStr}}</span>
          </li>
        </ul>
      </div>
      <div
        class="wrap-right"
        :style="{background: `url(${data.growth_template_info && data.growth_template_info.lesson_flow}) no-repeat 100%/cover`}"
      ></div>
    </div>
  </el-card>
</template>

<script>
import { Card } from 'element-ui'

export default {
  components: {
    'ElCard': Card
  },
  props: ['data'],
  data () {
    return {
      rubList: [],
      rubStr: ''
    }
  },
  watch: {
    'data': {
      handler (val) {
        this.$nextTick(() => {
          // 有换行
          if (!val) return
          const str = val.growth_template_info && val.growth_template_info.lesson_heavy_points
          if (/[\n\r]/g.test(str)) {
            this.rubList = str.split(/[\n\r]/g).filter(row => row)
          } else {
            this.rubStr = str
          }
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './view.styl';

.wrap-rub {
  .content {
    overflow: auto;

    li {
      margin-bottom: 10px;
    }

    .icon {
      color: $themeColor;
      font-size: 14px;
      margin-right: 8px;
    }

    span {
      font-size: 12px;
      word-break: break-all;
    }
  }

  .wrap-right {
    height: 200px;
    border-radius: 10px;
    border: 1px solid rgba(0, 196, 170, 1);
  }
}
</style>
